import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RequestInformationConservazioneComponent } from './request-information-conservazione';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.request-information-conservazione', {
            url: '/request-information-conservazione',
            ncyBreadcrumb: {
                label: 'Richiesta Informazioni Conservazione',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Richiesta Informazioni Conservazione'
            },
            'views': {
                'homeContent': {
                    template: '<request-information-conservazione flex="100"></request-information-conservazione>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RequestInformationConservazioneModule: string = ng
    .module('request-information-conservazione', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('requestInformationConservazione', RequestInformationConservazioneComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/request-information-conservazione/request-information-conservazione.module.ts